let bDesktop; // true if in Desktop mode

// Initiate event handlers
function initNav() {
    'use strict';
    // .collapse is only visible in Desktop mode
    bDesktop = jQuery('.collapse').is(':visible');
    let oMenus = jQuery('.navbar-nav .dropdown'),
        nTimer;
    if (!bDesktop) {
        // Disable hover events for Mobile
        oMenus.off();
    } else {
        oMenus.on({
            mouseenter: function (event) {
                event.preventDefault();
                clearTimeout(nTimer);
                jQuery('.header.headspace').addClass('dropdown-open');
                oMenus.removeClass('show');
                jQuery(this).addClass('show');
            },
            mouseleave: function (event) {
                nTimer = setTimeout(function () {
                    jQuery('.header.headspace').removeClass('dropdown-open');
                    oMenus.removeClass('show');
                }, 500);
            },
        });
    }

    jQuery('li.menu-item-has-children .toggle').on(
        'click touchend',
        function (e) {
            e.preventDefault();

            jQuery(this)
                .toggleClass('active')
                .parent()
                .parent()
                .find('.dropdown-menu')
                .toggleClass('show');
        }
    );

    // Toggle the nav open and closed
    jQuery('.navbar-toggler').on('click touchend', function () {
        jQuery(this).addClass('active');
        jQuery('#secondary-nav').addClass('active');
        jQuery('body').addClass('menu-open');
    });

    jQuery('.close-menu, #secondary-nav .overlay').on(
        'click touchend',
        function () {
            jQuery('#secondary-nav').removeClass('active');
            jQuery('body').removeClass('menu-open');
        }
    );
}

(function ($) {
    initNav();

    $(window).resize(initNav);
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main-nav-controller.js